enum CompanyResourceType {
  PROVIDER = 1,
  PATIENT_CONTACT,
  COMMUNITY_RESOURCE,
  NON_PROVIDER_CLINICIAN,
  VOLUNTEER,
}

export default CompanyResourceType;



// WEBPACK FOOTER //
// ./src/models/resource-management/company-resource-type.enum.ts